import React from 'react';
import Header from '@/components/Header';
import ManufacturerLogos from '@/components/ManufacturerLogos';
import HeroSection from '@/components/sections/HeroSection';
import FeaturedListingsSection from '@/components/sections/FeaturedListingsSection';
import FeaturesSection from '@/components/sections/FeaturesSection';
import CountrySection from '@/components/sections/CountrySection';
import Footer from '@/components/sections/Footer';

export default function ComingSoonPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <ManufacturerLogos />
      <HeroSection />
      <FeaturedListingsSection />
      <FeaturesSection />
      <CountrySection />
      <Footer />
    </div>
  );
}